import { Banner } from '@evisort/eds/components/Banner/Banner';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  retry: {
    id: 'InlineApiError.retry',
    defaultMessage: 'Retry',
    description: 'Button label for retrying a failed API request',
  },
});

interface InlineApiErrorProps {
  message: string;
  onRetry?: () => void;
  title: string;
}

export const InlineApiError = ({
  message,
  onRetry,
  title,
}: InlineApiErrorProps) => {
  const intl = useIntl();
  const retryLabel = intl.formatMessage(messages.retry);

  return (
    <Banner
      action={
        onRetry && {
          label: retryLabel,
          onClick: onRetry,
          text: retryLabel,
          variant: 'secondary',
        }
      }
      status="critical"
      text={message}
      title={title}
    />
  );
};
